import { SeatType } from '@vista-digital/ocapi-types/v1';
import { getFormattedSeatLabel } from '../../../utils/seat-utils';
export const getAriaLabelForSeat = (seat, isAvailable, accessibilityText, displayText, i18n) => {
    const seatLabel = getFormattedSeatLabel(seat, displayText, i18n);
    if (!isAvailable) {
        return getAriaLabelFromFormat(accessibilityText.unavailableSeatAriaLabelFormat, seatLabel, i18n);
    }
    switch (seat.type) {
        case SeatType.SofaLeft:
            return getAriaLabelFromFormat(accessibilityText.sofaLeftSeatAriaLabelFormat, seatLabel, i18n);
        case SeatType.SofaMiddle:
            return getAriaLabelFromFormat(accessibilityText.sofaMiddleSeatAriaLabelFormat, seatLabel, i18n);
        case SeatType.SofaRight:
            return getAriaLabelFromFormat(accessibilityText.sofaRightSeatAriaLabelFormat, seatLabel, i18n);
        case SeatType.Wheelchair:
            return getAriaLabelFromFormat(accessibilityText.wheelchairSeatAriaLabelFormat, seatLabel, i18n);
        case SeatType.Companion:
            return getAriaLabelFromFormat(accessibilityText.companionSeatAriaLabelFormat, seatLabel, i18n);
        case SeatType.Normal:
        default:
            return getAriaLabelFromFormat(accessibilityText.normalSeatAriaLabelFormat, seatLabel, i18n);
    }
};
const getAriaLabelFromFormat = (format, seatLabel, i18n) => {
    return i18n.template(format, { formattedSeatLabel: seatLabel });
};
